import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "reference-list__separate" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSubHeading = _resolveComponent("BaseSubHeading")!
  const _component_ReferenceComponentParentList = _resolveComponent("ReferenceComponentParentList")!

  return (_ctx.content.length)
    ? (_openBlock(), _createBlock(_component_ReferenceComponentParentList, {
        key: 0,
        searchList: _ctx.content,
        componentType: _ctx.componentType
      }, {
        header: _withCtx(() => [
          _createVNode(_component_BaseSubHeading, {
            weight: "600",
            size: "medium",
            color: "monochrome-06",
            className: "reference-list__header"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Keyboard Shortcuts: ")
            ]),
            _: 1
          })
        ]),
        item: _withCtx(({ option }) => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_BaseSubHeading, {
              weight: "400",
              size: "medium",
              color: "monochrome-07",
              className: "reference-list__separate-left"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t(`reference.${option}.key`)), 1)
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_BaseSubHeading, {
              weight: "400",
              size: "medium",
              color: "monochrome-05",
              darkColor: "monochrome-04",
              className: "reference-list__separate-right"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t(`reference.${option}.desc`)), 1)
              ]),
              _: 2
            }, 1024)
          ])
        ]),
        _: 1
      }, 8, ["searchList", "componentType"]))
    : _createCommentVNode("", true)
}